import { render } from "./software.vue?vue&type=template&id=e01453c0&scoped=true"
import script from "./software.vue?vue&type=script&lang=js"
export * from "./software.vue?vue&type=script&lang=js"

import "./software.vue?vue&type=style&index=0&id=e01453c0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01453c0"]])

export default __exports__